import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/header';
import Card from '../../components/Card';
import Sidebar from '../../components/sidebar/sidebar';
import PackageMappingList from './PackageMappingList';
import AddAppsTab from './AddAppsTab';
import CVEUpdateTab from './CVEUpdateTab';

const PackageManager = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from URL
  const getActiveTab = () => {
    if (location.pathname.includes('/addapps')) return 'ManagePackage';
    if (location.pathname.includes('/cveupdates')) return 'CVEUpdates';
    return 'PackageMapping';
  };

  const [activeTab, setActiveTab] = useState<'PackageMapping' | 'ManagePackage' | 'CVEUpdates'>(getActiveTab());

  // Update active tab when URL changes
  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [location.pathname]);

  // Get dynamic header title based on active tab
  const getHeaderTitle = () => {
    switch (activeTab) {
      case 'PackageMapping':
        return 'Package Mapping';
      case 'ManagePackage':
        return 'Manage Package';
      case 'CVEUpdates':
        return 'CVE Updates';
      default:
        return 'Package Manager';
    }
  };

  const handleTabChange = (tab: 'PackageMapping' | 'ManagePackage' | 'CVEUpdates') => {
    setActiveTab(tab);
    if (tab === 'PackageMapping') {
      navigate('/packagemanager');
    } else if (tab === 'ManagePackage') {
      navigate('/packagemanager/addapps');
    } else if (tab === 'CVEUpdates') {
      navigate('/packagemanager/cveupdates');
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'PackageMapping':
        return <PackageMappingList />;
      case 'ManagePackage':
        return <AddAppsTab />;
      case 'CVEUpdates':
        return <CVEUpdateTab />;
      default:
        return <PackageMappingList />;
    }
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title={getHeaderTitle()} dropdown={2} />
        <Card className="flex-1">
          <div className="flex items-center justify-between mb-4">
            {/* Tab Buttons */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              {['Package Mapping', 'Manage Package', 'CVE Updates'].map((tab) => {
                const tabKey = tab === 'Package Mapping' ? 'PackageMapping' : tab === 'Manage Package' ? 'ManagePackage' : 'CVEUpdates';
                return (
                  <button
                    key={tab}
                    onClick={() => handleTabChange(tabKey)}
                    style={{
                      padding: '0.5rem 1rem',
                      borderRadius: '6px',
                      borderRight: activeTab === tabKey ? '5.62px solid #D12929' : '5.62px solid #474646',
                      borderLeft: activeTab === tabKey ? '5.62px solid #D12929' : '5.62px solid #474646',
                      color: '#fff',
                      cursor: 'pointer',
                      backgroundColor: 'transparent',
                    }}
                  >
                    {tab}
                  </button>
                );
              })}
            </div>
          </div>
          {renderContent()}
        </Card>
      </div>
    </div>
  );
};

export default PackageManager;
